import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = new Date(value);
      return {
        day: parseInt(date.getDate() + '', 10),
        month: parseInt((date.getMonth() + 1) + '', 10),
        year: parseInt(date.getFullYear() + '', 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): any | null {
    return date ? new Date(date.year, date.month - 1, date.day).valueOf() : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    const day = this.padNum(date?.day, 2);
    const month = this.padNum(date?.month, 2);
    const year = date?.year
    return date ? day + this.DELIMITER + month + this.DELIMITER + year : '';
  }

  padNum(num: any, length: any) {
    if (num) {
      return num.toString().padStart(length, '0');
    } else {
      return "";
    }
    
  };
  
}
